var map = {
	"./android.avif": 5486,
	"./aws.avif": 6564,
	"./azure.avif": 3482,
	"./dot-net.avif": 9024,
	"./flutter.avif": 4464,
	"./ios.avif": 3684,
	"./iot.avif": 7789,
	"./java.avif": 7543,
	"./kotlin.avif": 6126,
	"./laravel.avif": 3688,
	"./mongo.avif": 4549,
	"./mysql.avif": 8383,
	"./node-js.avif": 7461,
	"./php.avif": 4173,
	"./png/android.png": 3772,
	"./png/aws.png": 5174,
	"./png/azure.png": 6472,
	"./png/dot-net.png": 786,
	"./png/flutter.png": 5179,
	"./png/ios.png": 6710,
	"./png/iot.png": 9753,
	"./png/java.png": 5169,
	"./png/kotlin.png": 9934,
	"./png/laravel.png": 2654,
	"./png/mongo.png": 3090,
	"./png/mysql.png": 495,
	"./png/node-js.png": 5069,
	"./png/php.png": 2621,
	"./png/python.png": 7259,
	"./png/react-js.png": 9698,
	"./png/redis.png": 7908,
	"./png/swift.png": 176,
	"./png/woo.png": 5536,
	"./png/wordpress.png": 3928,
	"./python.avif": 5077,
	"./react-js.avif": 1954,
	"./redis.avif": 550,
	"./swift.avif": 4898,
	"./woo.avif": 8030,
	"./wordpress.avif": 2974
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7665;